import * as moment from 'moment';
import routes from '../../../router';
import testData from './testData';

const loadScreen = screen => {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === 'dev') {
      const response = {
        data: testData.data.screen,
        serverTime: testData.data.time,
        currentTime: Number(moment(testData.data.time).format('X')),
        screensCount: testData.data.screens_count,
      };
      setTimeout(() => resolve(response), 1000);
    } else {
      const headers = {
        headers: {
          Accept: 'application/json',
        },
        method: 'GET',
      };

      fetch(`${routes.scheme_screen}?screen=${screen}`, headers)
        .then(response => response.json())
        .then(json => {
          if (json.data) {
            resolve({
              data: json.data.screen,
              serverTime: json.data.time,
              currentTime: Number(moment(json.data.time).format('X')),
              screensCount: json.data.screens_count,
            });
          } else {
            reject(new Error(`Ошибка загрузки данных: ${json.errors}`));
          }
        })
        .catch(() => {
          reject(new Error('Ошибка загрузки данных'));
        });
    }
  });
}

export default loadScreen;